import { phone } from 'phone';

export default function formatPhoneNumberLink(tel: string) {
  const normal = tel
    .replace(/\(0\)/g, '')
    .replace(/^\+/, '')
    .replace(/[^0-9]+/g, '');
  const result = phone(`+${normal}`, {
    validateMobilePrefix: false
  });
  if (result.isValid) {
    return `tel:${result.phoneNumber}`;
  }
  return `tel:+${normal}`;
}
